<template>
    <div class="about-us">
        <!-- 应用信息 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-info"></i>应用信息
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-document"></i>
                    <span>当前版本</span>
                </div>
                <div class="setting-content">
                    <span class="version-text">{{ currentVersion }}</span>
                </div>
            </div>
            <div class="setting-item" v-if="latestVersion && latestVersion !== currentVersion">
                <div class="setting-label">
                    <i class="el-icon-top"></i>
                    <span>最新版本</span>
                </div>
                <div class="setting-content">
                    <span class="version-text new-version">{{ latestVersion }}</span>
                </div>
            </div>
        </div>

        <!-- 更新检查 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-refresh"></i>更新检查
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-search"></i>
                    <span>检查更新</span>
                </div>
                <div class="setting-content">
                    <el-button type="primary" size="small" :loading="checking" @click="checkForUpdate"
                        :disabled="updating">
                        {{ checking ? '检查中...' : '检查更新' }}
                    </el-button>
                </div>
            </div>
            <div class="update-status" v-if="updateStatus">
                <el-alert :title="updateStatus" :type="updateStatusType" :closable="false" show-icon>
                </el-alert>
            </div>
            <div class="setting-item" v-if="hasUpdate && !updating && !updateDownloaded">
                <div class="setting-label">
                    <i class="el-icon-download"></i>
                    <span>自动更新</span>
                </div>
                <div class="setting-content">
                    <el-button type="success" size="small" @click="startUpdate">
                        立即更新
                    </el-button>
                </div>
            </div>
            <div class="update-progress" v-if="updating">
                <div class="progress-info">
                    <span>正在下载更新...</span>
                    <span class="progress-percent">{{ updateProgress }}%</span>
                </div>
                <el-progress :percentage="updateProgress" :status="updateProgress === 100 ? 'success' : ''">
                </el-progress>
            </div>
            <div class="setting-item" v-if="updateDownloaded">
                <div class="setting-label">
                    <i class="el-icon-success"></i>
                    <span>安装更新</span>
                </div>
                <div class="setting-content">
                    <el-button type="primary" size="small" @click="installUpdate">
                        立即安装并重启
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AboutUs",
    data() {
        return {
            currentVersion: '',
            latestVersion: '',
            checking: false,
            updating: false,
            hasUpdate: false,
            updateStatus: '',
            updateStatusType: 'info',
            updateProgress: 0,
            updateDownloaded: false
        }
    },
    methods: {
        init() {
            // 获取当前版本号
            window.electronAPI.invoke('get-app-version').then(version => {
                this.currentVersion = version || '未知';
            }).catch(() => {
                this.currentVersion = '未知';
            });

            // 监听更新事件
            window.electronAPI.receive('update-available', (info) => {
                this.latestVersion = info.version;
                this.hasUpdate = true;
                this.updateStatus = `发现新版本 ${info.version}，是否立即更新？`;
                this.updateStatusType = 'success';
                this.checking = false;
            });

            window.electronAPI.receive('update-not-available', () => {
                this.updateStatus = '当前已是最新版本';
                this.updateStatusType = 'success';
                this.checking = false;
                this.hasUpdate = false;
            });

            window.electronAPI.receive('update-error', (error) => {
                this.updateStatus = `更新检查失败: ${error}`;
                this.updateStatusType = 'error';
                this.checking = false;
            });

            window.electronAPI.receive('download-progress', (progress) => {
                this.updateProgress = Math.round(progress.percent || 0);
            });

            window.electronAPI.receive('update-downloaded', () => {
                this.updateProgress = 100;
                this.updateStatus = '更新下载完成，可以立即安装';
                this.updateStatusType = 'success';
                this.updating = false;
                this.updateDownloaded = true;
            });

        },
        checkForUpdate() {
            this.checking = true;
            this.updateStatus = '';
            this.hasUpdate = false;
            this.latestVersion = '';
            this.updateDownloaded = false;
            window.electronAPI.invoke('check-for-update').then(result => {
                if (result === false) {
                    // 开发模式下返回 false
                    this.updateStatus = '开发模式下无法检查更新，请在正式版本中使用此功能';
                    this.updateStatusType = 'info';
                    this.checking = false;
                } else if (!result) {
                    this.updateStatus = '无法连接到更新服务器';
                    this.updateStatusType = 'warning';
                    this.checking = false;
                }
                // 如果 result 为 true，说明检查已开始，等待事件回调
            }).catch(error => {
                this.updateStatus = `检查更新失败: ${error.message || error}`;
                this.updateStatusType = 'error';
                this.checking = false;
            });
        },
        startUpdate() {
            this.updating = true;
            this.updateProgress = 0;
            this.updateStatus = '正在下载更新...';
            this.updateStatusType = 'info';
            this.updateDownloaded = false;
            window.electronAPI.invoke('start-update').catch(error => {
                this.updateStatus = `更新失败: ${error.message || error}`;
                this.updateStatusType = 'error';
                this.updating = false;
                this.$message.error('更新失败，请稍后重试');
            });
        },
        installUpdate() {
            this.$confirm('安装更新后应用将自动重启，是否继续？', '确认安装', {
                confirmButtonText: '立即安装',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.electronAPI.invoke('install-update').then(() => {
                    this.$message.success('正在安装更新，应用将自动重启...');
                }).catch(error => {
                    this.$message.error(`安装失败: ${error.message || error}`);
                });
            })
        }
    }
}
</script>

<style scoped lang="scss">
.about-us {
    padding: 15px;
    background: #fafbfc;
    min-height: 400px;

    // 表单区域
    .form-section {
        background: white;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #f0f0f0;

        .section-title {
            margin: 0 0 15px 0;
            font-size: var(--im-font-size-larger);
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
            padding-bottom: 8px;
            border-bottom: 1px solid #f5f5f5;

            i {
                color: var(--im-color-primary);
                font-size: 16px;
            }
        }
    }

    // 设置项
    .setting-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
            border-bottom: none;
        }

        .setting-label {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100px;
            font-weight: 500;
            color: var(--im-text-color-light);
            font-size: var(--im-font-size);

            i {
                color: var(--im-color-primary);
                font-size: var(--im-font-size-large);
            }
        }

        .setting-content {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .version-text {
                font-size: var(--im-font-size);
                color: var(--im-text-color);
                font-weight: 500;

                &.new-version {
                    color: var(--im-color-primary);
                    font-weight: 600;
                }
            }
        }
    }

    .update-status {
        margin-top: 12px;
    }

    .update-progress {
        margin-top: 12px;
        padding: 12px;
        background: #f5f7fa;
        border-radius: 4px;

        .progress-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            font-size: var(--im-font-size);
            color: var(--im-text-color-light);

            .progress-percent {
                font-weight: 600;
                color: var(--im-color-primary);
            }
        }
    }
}
</style>
